import React from 'react';
import { FixedTab, RouteTabs } from '../../../components/RouteTabs';
import CoinUnitPriceFinalizedView from './CoinUnitPriceFinalizedView';
import CoinUnitPriceInProgressView from './CoinUnitPriceInProgressView';
import CoinUnitPriceToBeFinalizedView from './CoinUnitPriceToBeFinalizedView';

interface IProps {
  path: string;
}

const CoinUnitPrice = (props: IProps): JSX.Element => {
  const { path } = props;

  return (
    <RouteTabs path={`${path}/coin`} isNested={true}>
      <FixedTab label="In Progress">
        <CoinUnitPriceInProgressView />
      </FixedTab>
      <FixedTab label="To be Finalized" uri="tobe">
        <CoinUnitPriceToBeFinalizedView />
      </FixedTab>
      <FixedTab label="Finalized" uri="final">
        <CoinUnitPriceFinalizedView />
      </FixedTab>
    </RouteTabs>
  );
};

export default CoinUnitPrice;
